import { apiFetch } from "./client";

export const fetchOrderById = (orderId) =>
  apiFetch(`/enduser/get-order/${orderId}/`, {
    credentials: "include",
  });

export const fetchPreorderOrderById = (orderId) =>
  apiFetch(`/enduser/preorder-orders/${orderId}/`, {
    credentials: "include",
  });

export const fetchPreorderOrderStatus = (orderId) =>
  apiFetch(`/enduser/preorder/status/${orderId}/`, {
    credentials: "include",
  });

export const fetchPreorderOrderDetails = async (orderId) => {
  try {
    return await fetchPreorderOrderStatus(orderId);
  } catch (error) {
    if ([400, 404, 405].includes(error?.status)) {
      return fetchPreorderOrderById(orderId);
    }
    throw error;
  }
};

export const completePurchase = (payload = null) =>
  apiFetch("/enduser/complete-purchase/", {
    method: "POST",
    credentials: "include",
    body: payload,
  });

export const getOrderStatus = (orderId) =>
  apiFetch(`/enduser/status/${orderId}/`, {
    credentials: "include",
  });

export const createProductOrder = ({ payment_method } = {}) => {
  const payload = payment_method ? { payment_method } : null;
  return completePurchase(payload);
};

export const createPreorderOrder = ({ payment_method } = {}) =>
  apiFetch("/enduser/preorder/checkout/", {
    method: "POST",
    credentials: "include",
    body: payment_method ? { payment_method } : null,
  });

export const submitQrPaymentProof = (paymentId, file, qrReference) => {
  const formData = new FormData();
  if (file) {
    formData.append("proof_image", file);
  }
  if (qrReference) {
    formData.append("qr_reference", qrReference);
  }

  return apiFetch(`/enduser/payment/qr-submit/${paymentId}/`, {
    method: "POST",
    credentials: "include",
    body: formData,
  });
};

export const submitPreorderQrPaymentProof = (file, qrReference) => {
  const formData = new FormData();
  if (file) {
    formData.append("proof_image", file);
  }
  if (qrReference) {
    formData.append("qr_reference", qrReference);
  }

  return apiFetch("/enduser/preorder/payment/qr-submit/", {
    method: "POST",
    credentials: "include",
    body: formData,
  });
};
